// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xuzo","field":"styles_field__2xxdo","fieldCol":"styles_fieldCol__1ks6b","diffCol":"styles_diffCol__18rcG","diff":"styles_diff__1ynPl"};